export default __webpack_public_path__ + "static/media/image-cushion-g-w.bbe1e701.png";